import { render, staticRenderFns } from "./statisticsItem.vue?vue&type=template&id=3e2d0f1a&scoped=true"
import script from "./statisticsItem.vue?vue&type=script&lang=js"
export * from "./statisticsItem.vue?vue&type=script&lang=js"
import style0 from "./statisticsItem.vue?vue&type=style&index=0&id=3e2d0f1a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2d0f1a",
  null
  
)

export default component.exports